import React from 'react';

import PropTypes from 'prop-types';

import styles from './WidgetHeader.scss';

function WidgetHeader(props) {
    const {
        children,
    } = props;

    return (
        <span className={styles.header}>
            {children}
        </span>
    );
}

WidgetHeader.propTypes = {
    children: PropTypes.any,
};

export default WidgetHeader;
